export default "<a href=\"{{youtubeLink}}\" target=\"_blank\">View on Youtube</a>\r\n"